import CardListsExpandableCardListHeaderController from "../../../card_lists/assets/javascript/card-lists-expandable-card-list-header-controller";

export default class extends CardListsExpandableCardListHeaderController {}



// WEBPACK FOOTER //
// ./app/components/templates/assets/javascript/templates-marketing-activity-template-card-header-controller.js